import { StatusCode } from '@/error-handling/types';
import type { QueryClientConfig } from '@tanstack/react-query';

const onErrorHandling = (error: unknown) => {
  if ((error as any)?.status === StatusCode.Unauthorised) {
    return true;
  }
  return false;
};

export const generateQueryConfig = (): QueryClientConfig => {
  const defaultQueriesOptions = {
    // https://tanstack.com/query/latest/docs/framework/react/guides/window-focus-refetching
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 1,
  };

  return {
    defaultOptions: {
      queries: {
        ...defaultQueriesOptions,
        throwOnError: onErrorHandling,
      },
      mutations: {
        throwOnError: onErrorHandling,
      },
    },
  };
};
